import React from 'react';
import DayOfTheWeekPicker from 'design-system/day-of-the-week-picker/DayOfTheWeekPicker';
const WeeklyView = ({ selectedDay, onSelectDay, }) => (<DayOfTheWeekPicker selectedDay={selectedDay} onSelectDay={onSelectDay}/>);
export default WeeklyView;
